import {useMutation} from '@tanstack/react-query';
import {PostRequestRegisterDocumentParams} from 'domain/usecases/others/facial-biometric';
import {postRegisterDocument} from '../services/postRegisterDocument';

export const useRegisterDocumentMutation = () =>
	useMutation({
		mutationFn: (params: PostRequestRegisterDocumentParams) => postRegisterDocument(params),
	});
